import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

// genres/tvShowGenres is an action type prefix and is used
// internally with pending, fulfilled, rejected
// each of these createAsyncThunks return promises
export const fetchTVShowGenres = createAsyncThunk(
  "genres/tvShowGenres",
  async () => {
    console.log("calling GET tv show genres...");
    const response = await axios.get(`${BASE_URL}/api/tvshow/genres`);
    console.log("GET tvs show genres response: ", response);
    return response.data;
  }
);

const tvShowGenreSlice = createSlice({
  name: "tvShowGenres",
  initialState: {
    tvShowGenres: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      // fetch tv show genres
      .addCase(fetchTVShowGenres.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTVShowGenres.fulfilled, (state, action) => {
        state.tvShowGenres = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchTVShowGenres.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default tvShowGenreSlice.reducer;
